// Contrail V3.7.0 — mobile Alerts tab: live in-app events (email-only events stay hidden, as on desktop).
// Mark seen one by one or all at once; tap an event to open the object at that position. Rules are edited on desktop.
import SnoozeMenu from "../ui/SnoozeMenu";
import { useState } from "react";
import type { Device } from "../lib/supabase";
import { ago, fijiTime } from "../lib/format";
import { orgApi, type AlertEvent } from "../lib/org";

export default function MobileAlerts({ events, setEvents, devices, now, onOpen }: {
  events: AlertEvent[]; setEvents: (f: (e: AlertEvent[]) => AlertEvent[]) => void; devices: Device[]; now: number;
  onOpen: (deviceId: string, lat: number | null, lng: number | null) => void;
}) {
  const [onlyNew, setOnlyNew] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const open = events.filter((e) => !e.ack_at).length;
  const shown = events.filter((e) => !onlyNew || !e.ack_at);
  const name = (id: string) => devices.find((d) => d.id === id)?.name ?? "—";
  async function ack(e: AlertEvent) {
    try { await orgApi("POST", `alert-events/${e.id}/ack`, {}); setEvents((p) => p.map((x) => (x.id === e.id ? { ...x, ack_at: new Date().toISOString() } : x))); }
    catch (x: any) { setErr(x.message); }
  }
  async function ackAll() {
    try { await orgApi("POST", "alert-events/ack-all", {}); const t = new Date().toISOString(); setEvents((p) => p.map((x) => (x.ack_at ? x : { ...x, ack_at: t }))); }
    catch (x: any) { setErr(x.message); }
  }
  return (
    <div className="m-panel">
      <div className="m-panel-head">
        <div className="m-alerts-top"><h1>Alerts</h1><SnoozeMenu className="m-snz" /></div>
        <div className="m-chips">
          <button type="button" className={!onlyNew ? "on" : ""} onClick={() => setOnlyNew(false)}>All</button>
          <button type="button" className={onlyNew ? "on" : ""} onClick={() => setOnlyNew(true)}>New ({open})</button>
          {open > 0 && <button type="button" className="m-chip-act" onClick={ackAll}>Mark all seen</button>}
        </div>
        {err && <div className="error">{err}</div>}
      </div>
      <ul className="m-list m-events">
        {shown.map((e) => (
          <li key={e.id} className={e.ack_at ? "seen" : "new"}>
            <button type="button" onClick={() => onOpen(e.device_id, e.lat, e.lng)}>
              <i className={`evdot ev-${e.type}`} />
              <span className="m-row-main"><b>{e.message}</b><span className="sub">{name(e.device_id)} · {fijiTime(e.at)} · {ago(e.at, now)}</span></span>
            </button>
            {!e.ack_at && <button type="button" className="m-seen" onClick={() => ack(e)}>Seen</button>}
          </li>
        ))}
        {!shown.length && <li className="m-empty">{onlyNew ? "Nothing new." : "No alerts yet. Your company's alerts are set up on the desktop version."}</li>}
      </ul>
    </div>
  );
}
